import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  CardHeader,
  makeStyles,
  Text,
} from '@knockrentals/knock-shared-web';

const useStyles = makeStyles({
  affordableCard: {
    marginTop: '24px',
    padding: '20px 24px',
  },
  affordableCardHeader: {
    paddingBottom: '8px',
  },
});

const AffordableCard = ({ children, subtitle, title }) => {
  const classes = useStyles();

  return (
    <Card className={classes.affordableCard} variant="outlined">
      <CardHeader
        className={classes.affordableCardHeader}
        disableTypography
        subheader={
          <Text color="textSecondary" variant="body2">
            {subtitle}
          </Text>
        }
        title={
          <Text color="textPrimary" variant="subtitle2">
            {title}
          </Text>
        }
      />

      <CardContent>{children}</CardContent>
    </Card>
  );
};

AffordableCard.propTypes = {
  children: PropTypes.node,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

export default AffordableCard;
